import type { TagSheetParseResult } from '../types';
import type { LineItemHeaderDisplay } from './types';

export const getLineItemHeaderDisplay = (
  parseResult: TagSheetParseResult | null,
  lineItemId: string
): LineItemHeaderDisplay => {
  const matched = parseResult?.lineItems.find((lineItem) => lineItem.id === lineItemId);

  return {
    lineItemId,
    lineItemName: matched?.name ?? '',
    adProductDisplayName: matched?.adProduct?.displayName ?? '',
  };
};
